import { Modal } from '@/components/ui/Modal';
import { useUiStore } from '@/store/uiStore';

const SHORTCUTS: { keys: string[]; action: string }[] = [
  { keys: ['/'], action: 'Focus the URL input' },
  { keys: ['Ctrl', 'K'], action: 'Focus the URL input' },
  { keys: ['V'], action: 'Paste URL from clipboard' },
  { keys: ['?'], action: 'Show this help' },
  { keys: ['Esc'], action: 'Close dialogs' },
];

export function ShortcutsHelp() {
  const open = useUiStore((s) => s.shortcutsOpen);
  const setOpen = useUiStore((s) => s.setShortcutsOpen);

  return (
    <Modal open={open} onClose={() => setOpen(false)} title="Keyboard shortcuts">
      <ul className="space-y-3">
        {SHORTCUTS.map((shortcut) => (
          <li key={shortcut.action + shortcut.keys.join('')} className="flex items-center justify-between gap-4">
            <span className="text-sm text-zinc-400">{shortcut.action}</span>
            <span className="flex gap-1">
              {shortcut.keys.map((key) => (
                <kbd
                  key={key}
                  className="rounded-lg border border-white/10 bg-white/5 px-2 py-1 text-xs font-semibold text-zinc-300"
                >
                  {key}
                </kbd>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
